import { useParams } from "react-router-dom";

function ConfirmaBaja(){
    const params = useParams().x;

    return (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
            <h2>Suscripción cancelada</h2>
            <p>Tu suscripción ha sido cancelada, si deseas volver, puedes contactarnos para que te sigan llegando este tipo de correos electronicós.</p>
        </div>
    )
}

export default ConfirmaBaja;